import React, { useMemo } from 'react'
import AdminSalaryFilterRowContainer from '../../containers/admin/adminSalaryFilterRow.container'
import AdminSalaryFormContainer from '../../containers/admin/adminSalaryForm.container'
import ReactPaginate from 'react-paginate'
import FontAwesome from 'react-fontawesome'
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  Checkbox,
  Divider,
  Dialog,
  DialogTitle,
  LinearProgress,
  Button,
  DialogContent,
  DialogActions,
  IconButton,
  Collapse,
  DialogContentText
} from '@material-ui/core'
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons'
import { convertNameToState } from '../../utils/invoice.utils'
import DateTimeFormat from '../../utils/DateTimeFormat'
import {
  useForm,
  filterEmpty,
  addDynamicForm,
  deleteDynamicForm
} from '../../form'
import { ADMIN_SALARY_PAGE_SIZE } from '../../constants/index'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import { withStyles } from '@material-ui/styles'
import classNames from 'classnames'
//excel
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import { useDispatch, useSelector } from 'react-redux'
import { getAdminSalaryUlosottoInfo, removePaymentDialog  } from '../../actions'
import { showSalaryItemLoader } from '../../selectors/admin.selectors'

const styles = (theme) => ({
  tableCell: {
    fontSize: '13px'
  },
  tableHead: {
    fontSize: '13px',
    fontWeight: 'bold',
    borderBottom: '1px solid gray'
  },
  invoiceCell: {
    maxWidth: '300px',
    [theme.breakpoints.down('md')]: {
      maxWidth: '150px'
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '250px'
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '400px'
    }
  }
})

const defaultValues = {
  salaryId: '',
  firstname: '',
  start_date: null,
  end_date: null,
  has_yel: false,
  has_ulosotto: false,
  is_Pplasku: false,
  socialID: '',
  email: '',
  status: '',
  yelSelect: '',
  yearSelect: `${new Date().getFullYear()}`,
  adminSalaryPageSize: ADMIN_SALARY_PAGE_SIZE
}

const SalaryPanel = ({
  classes,
  salarySearchRows,
  salarySearchSummary,
  selected,
  salarySearchPages,
  searchAdminWages,
  warnSalaryToPay,
  //isToPaySalaryId,
  showSalaryPDF,
  isToLiftSalary,
  cancelUpdateAdminSalaryStatus,
  updateAdminSalaryStatus,
  isSalaryRowSelected,
  confirmSalaryToPay,
  isImportSalary,
  isValidBatch,
  isIRValidBatch,
  isIRCacelReportValidBatch,
  importKassavirtanenSalaries,
  salarySendtoIR,
  cancelSalaryIRReport,
  manualPaySalaries,
  selectedRows,
  updateSalaryStatusIR,
  adminSalaryPageSize,
  selectedSalaryRowIndex,
  shouldUpdateTable,
  updateAdminTableSuccess,
  allSalaryRecords,
  expandAdminSalary,
  shouldCloseSalaryForms,
  handleChangeAdminMenu,
  searchCompanyCustomers
}) => {
  // Global state to handle selected invoice expand row
  const [selectedIndex, setSelectedIndex] = React.useState(null)
  const [ulosottoDialogType, setUlosottoDialogType] = React.useState('')
  const [confirmManualPayDialog, setConfirmManualPayDialog] = React.useState(false)
  const salaryItemLoader = useSelector(showSalaryItemLoader)
  const [additionalUlosottoDialog, setAdditionalUlosottoDialog] = React.useState(false)
  const [open, setOpen] = React.useState(false)
  const dispatch = useDispatch()

  const  handleExpand = (el, globalIndex, index) => {
      const shouldExpand = open ? false : true
  
      if (!open) {
        dispatch(getAdminSalaryUlosottoInfo(el.uuid))
        expandAdminSalary(shouldExpand, el.id, globalIndex)
        dispatch(addDynamicForm('adminSalaryForm' + globalIndex))
        setOpen(!open)
      } else {
        dispatch(deleteDynamicForm('adminSalaryForm' + globalIndex))
        expandAdminSalary(shouldExpand, el.id, globalIndex)
        setOpen(!open)
      }
      setSelectedIndex(index)
  }

  const form = useForm({
    name: 'adminSearchCustomer',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    resetOnSubmit: false
  })

  const { getValues } = form

  const isUlosottoSalaryMissingInfo = useMemo(() => (
    selectedRows.some(item => {
      const {
        withdrawal_account_number,
        withdrawal_reference_number,
        Salary_type,
        ulosotto_sum_govpay,
        manual_sum_govpay,
        brutto_sum_govpay,
        normal_govpay_sum
      } = item
    
      return (
        [
          'govpay', 
          'manual_govpay',
          'brutto_govpay', 
          'normal_govpay'
        ].includes(Salary_type) &&
        (
          ulosotto_sum_govpay > 0 || 
          manual_sum_govpay > 0 ||
          brutto_sum_govpay > 0 ||
          normal_govpay_sum > 0
        ) &&
        !(
          withdrawal_account_number && 
          withdrawal_reference_number
        )
      )
    })
  ), [selectedRows])

  const isUlosottoSalaryMissingAmount = useMemo(() => (
    selectedRows.some(item => {
      const {
        Salary_type,
        ulosotto_sum_govpay,
        manual_sum_govpay
      } = item
    
      return (
        [
          'govpay', 
          'manual_govpay'
        ].includes(Salary_type) &&
        !(
          ulosotto_sum_govpay > 0 || 
          manual_sum_govpay > 0 
        )
      )
    })
  ), [selectedRows])

  function onSubmit(values) {
    searchAdminWages(null, true, values)
  }

  function handlePageChange(e) {
    searchAdminWages(e, true, filterEmpty(getValues()))
  }

  React.useEffect(() => {
    if (shouldUpdateTable) {
      searchAdminWages({ selected: selected }, true, filterEmpty(getValues()))
      updateAdminTableSuccess()
    }
  }, [shouldUpdateTable])

  // PI-296 get start_date and end_date values
  const startDate = getValues('start_date')
  const endDate = getValues('end_date')

  return (
    <>
      <div className="col-xs-12 col-sm-12 col-lg-12">
        <div className="panel panel-default">
          <div className="panel-body">
            <AdminSalaryFilterRowContainer form={form} />
          </div>
          <hr style={{ marginTop: '0px' }} />
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  className={classes.tableHead}
                  style={{
                    paddingLeft: '8px',
                    paddingRight: '4px',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word'
                  }}
                >
                  {/* Palkatunnus */}
                  Tunnus
                </TableCell>
                <TableCell
                  className={classNames(classes.tableHead, classes.invoiceCell)}
                  style={{
                    paddingLeft: '2px',
                    paddingRight: '2px',
                    textAlign: 'left'
                  }}
                >
                  Laskut
                </TableCell>
                <TableCell
                  className={classes.tableHead}
                  style={{
                    paddingLeft: '2px',
                    paddingRight: '2px',
                    textAlign: 'left'
                  }}
                >
                  {/* Käyttäjänimi */}
                  Nimi
                </TableCell>
                <TableCell
                  className={classes.tableHead}
                  style={{
                    paddingLeft: '2px',
                    paddingRight: '2px',
                    textAlign: 'right'
                  }}
                >
                  {/* Päivämäärä */}
                  PVM
                </TableCell>
                <TableCell
                  className={classes.tableHead}
                  style={{
                    paddingLeft: '2px',
                    paddingRight: '2px',
                    textAlign: 'right'
                  }}
                >
                  {/* Bruttopalkka */}
                  Brutto (€)
                </TableCell>
                <TableCell
                  className={classes.tableHead}
                  style={{
                    paddingLeft: '2px',
                    paddingRight: '2px',
                    textAlign: 'right'
                  }}
                >
                  {/* Nettopalkka */}
                  Netto (€)
                </TableCell>
                <TableCell
                  className={classes.tableHead}
                  style={{
                    width: '100px',
                    paddingLeft: '2px',
                    paddingRight: '2px',
                    textAlign: 'right',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    textAlign: 'right'
                  }}
                >
                  Ennakon-pidätys (€)
                </TableCell>
                <TableCell
                  className={classes.tableHead}
                  style={{
                    paddingLeft: '2px',
                    paddingRight: '2px',
                    textAlign: 'right'
                  }}
                >
                  YEL (€)
                </TableCell>
                <TableCell
                  className={classes.tableHead}
                  style={{
                    paddingLeft: '2px',
                    paddingRight: '2px',
                    textAlign: 'right',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word'
                  }}
                >
                  {/* Sotu-vähennys */}
                  Sotu (€)
                </TableCell>
                <TableCell
                  className={classes.tableHead}
                  style={{
                    paddingLeft: '2px',
                    paddingRight: '2px',
                    textAlign: 'right',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word'
                  }}
                >
                  {/* Palvelupalkkiovähennys */}
                  PP (€)
                </TableCell>
                <TableCell
                  className={classes.tableHead}
                  style={{
                    paddingLeft: '2px',
                    paddingRight: '2px',
                    textAlign: 'right'
                  }}
                >
                  {/* Kilometrikorvaus */}
                  Km (€)
                </TableCell>
                <TableCell
                  className={classes.tableHead}
                  style={{
                    paddingLeft: '2px',
                    paddingRight: '2px',
                    textAlign: 'right',
                    width: '80px'
                  }}
                >
                  Päiväraha (€)
                </TableCell>
                <TableCell
                  className={classes.tableHead}
                  style={{
                    paddingLeft: '1px',
                    paddingRight: '1px',
                    textAlign: 'right',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word'
                  }}
                >
                  {/* Muut kulukorvaukset (kuitit) */}
                  Kuitit (€)
                </TableCell>
                <TableCell
                  className={classes.tableHead}
                  style={{
                    paddingLeft: '2px',
                    paddingRight: '2px',
                    textAlign: 'right'
                  }}
                >
                  {/* Ulosotto */}
                  Uo (€)
                </TableCell>
                <TableCell
                  className={classes.tableHead}
                  style={{
                    paddingLeft: '2px',
                    paddingRight: '8px',
                    textAlign: 'right',
                    width: '90px'
                  }}
                >
                  Maksetaan (€)
                </TableCell>
                <TableCell
                  className={classes.tableHead}
                  style={{
                    paddingLeft: '8px',
                    paddingRight: '2px',
                    textAlign: 'left'
                  }}
                >
                  Vähennystila
                </TableCell>
                <TableCell
                  className={classes.tableHead}
                  style={{
                    paddingLeft: '2px',
                    paddingRight: '2px',
                    textAlign: 'left'
                  }}
                >
                  Ulosottotila
                </TableCell>
                <TableCell
                  className={classes.tableHead}
                  style={{
                    paddingLeft: '2px',
                    paddingRight: '2px',
                    textAlign: 'left'
                  }}
                >
                  Tila
                </TableCell>
                <TableCell
                  className={classes.tableHead}
                  style={{
                    paddingLeft: '2px',
                    paddingRight: '2px',
                    textAlign: 'left',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word'
                  }}
                >
                  Palkka maksettu
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {createSalaryRow(
                classes,
                salarySearchRows,
                selected,
                warnSalaryToPay,
                showSalaryPDF,
                adminSalaryPageSize,
                expandAdminSalary,
                shouldCloseSalaryForms,
                selectedIndex,
                setSelectedIndex,
                setUlosottoDialogType,
                open,
                setOpen,
                handleExpand,
                handleChangeAdminMenu,
                searchCompanyCustomers
              )}
            </TableBody>
          </Table>
          {isSalaryRowSelected ? (
            <div className="panel-body">
              <ul className="nav nav-pills pull-right">
                <li>
                  <Button
                    style={{ margin: '20px' }}
                    onClick={() => {
                      confirmSalaryToPay()
                    }}
                    variant="contained"
                  >
                    Jatka
                  </Button>
                </li>
              </ul>
            </div>
          ) : null}
          <Divider />
          <div className="panel-body">
            <ReactPaginate
              previousLabel={<i className="fa fa-chevron-left" />}
              nextLabel={<i className="fa fa-chevron-right" />}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={salarySearchPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
              forcePage={salarySearchPages === 0 ? undefined : selected}
            />
            {/* Salary Excel Download */}
            {createSalaryExcelReportButton(
              salarySearchRows,
              salarySearchSummary,
              selected,
              adminSalaryPageSize,
              startDate,
              endDate,
              allSalaryRecords
            )}
          </div>
          <Divider />
          {/* Salary summary section  */}
          <div
            className="row"
            style={{
              justifyContent: 'center',
              display: 'flex',
              flexDirection: 'row'
            }}
          >
            <div className="col-lg-8">
              <div className="col-lg-6">
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'left' }}
                      >
                        Bruttopalkka
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'right' }}
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(salarySearchSummary.total_gross_salary)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'left' }}
                      >
                        Ennakonpidätys
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'right' }}
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(salarySearchSummary.total_tax_cost)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'left' }}
                      >
                        Kilometrikorvaus
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'right' }}
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(salarySearchSummary.total_mileage_allowance)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'left' }}
                      >
                        Päiväraha
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'right' }}
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(salarySearchSummary.total_daily_allowance)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{
                          textAlign: 'left',
                          wordWrap: 'break-word',
                          whiteSpace: 'normal'
                        }}
                      >
                        Palvelupalkkiovähennys
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'right' }}
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(salarySearchSummary.total_service_cost)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'left' }}
                      >
                        Sotu-vähennys
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'right' }}
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(salarySearchSummary.total_social_contribution)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'left' }}
                      >
                        Maksetaan
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'right' }}
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(salarySearchSummary.total_take_home_pay)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'left' }}
                      >
                        YEL
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'right' }}
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(salarySearchSummary.total_yel_cost)}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
              <div className="col-lg-6">
                <Table style={{ textAlign: 'left' }}>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'left' }}
                      >
                        Ulosotto
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'right' }}
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(salarySearchSummary.total_ulosotto_sum)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{
                          textAlign: 'left',
                          wordWrap: 'break-word',
                          whiteSpace: 'normal'
                        }}
                      >
                        Muut kulukorvaukset (kuitit)
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'right' }}
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(salarySearchSummary.total_reimbursment_cost)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{
                          textAlign: 'left',
                          wordWrap: 'break-word',
                          whiteSpace: 'normal'
                        }}
                      >
                        Muut kulukorvaukset (kuitit) ALV-määrä
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'right' }}
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(salarySearchSummary.expenses.total_vat_amount)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{
                          textAlign: 'left',
                          wordWrap: 'break-word',
                          whiteSpace: 'normal'
                        }}
                      >
                        Kuitit (ALV 25,5%)
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'right' }}
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(salarySearchSummary.expenses.sum_incl_vat_25_5)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{
                          textAlign: 'left',
                          wordWrap: 'break-word',
                          whiteSpace: 'normal'
                        }}
                      >
                        Kuitit (ALV 24%)
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'right' }}
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(salarySearchSummary.expenses.sum_incl_vat_24)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{
                          textAlign: 'left',
                          wordWrap: 'break-word',
                          whiteSpace: 'normal'
                        }}
                      >
                        Kuitit (ALV 14%)
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'right' }}
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(salarySearchSummary.expenses.sum_incl_vat_14)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{
                          textAlign: 'left',
                          wordWrap: 'break-word',
                          whiteSpace: 'normal'
                        }}
                      >
                        Kuitit (ALV 10%)
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'right' }}
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(salarySearchSummary.expenses.sum_incl_vat_10)}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{
                          textAlign: 'left',
                          wordWrap: 'break-word',
                          whiteSpace: 'normal'
                        }}
                      >
                        Kuitit (ALV 0%)
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ textAlign: 'right' }}
                      >
                        {new Intl.NumberFormat('fi-FI', {
                          style: 'currency',
                          currency: 'EUR'
                        }).format(salarySearchSummary.expenses.sum_incl_vat_0)}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
            </div>
          </div>
          <Dialog
            open={additionalUlosottoDialog}
            onClose={() => setAdditionalUlosottoDialog(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle>
              <span
                style={{
                  padding: '30px 30px 0px 30px',
                  fontSize: '20px',
                  lineHeight: '40px'
                }}
              >
                Palkassa ei ole ulosottoa
              </span>
            </DialogTitle>
            <DialogActions>
              <ul className="nav nav-pills pull-right">
                <li>
                  <Button
                    style={{ margin: '20px' }}
                    onClick={() => {
                      const globalIndex =
                        selected * adminSalaryPageSize + selectedSalaryRowIndex
                      handleExpand(selectedRows[0], globalIndex, selectedSalaryRowIndex)
                      setAdditionalUlosottoDialog(false)
                      dispatch(removePaymentDialog())
                    }}
                    variant="contained"
                  >
                    Peruuta
                  </Button>
                </li>
                <li>
                  <Button
                    style={{ margin: '20px' }}
                    onClick={() => {
                      updateAdminSalaryStatus(selectedRows)
                      setAdditionalUlosottoDialog(false)
                    }}
                    variant="contained"
                  >
                    Vahvista
                  </Button>
                </li>
              </ul>
            </DialogActions>
          </Dialog>
          <Dialog
            open={salaryItemLoader}
            onClose={(_, reason) =>
              reason !== 'backdropClick' ? cancelUpdateAdminSalaryStatus() : null
            }
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              <span
                style={{
                  padding: '30px 30px 0px 30px',
                  fontSize: '20px',
                  lineHeight: '40px'
                }}
              >
                Tietoja päivitetään
              </span>
            </DialogTitle>
            <DialogContent>
              <LinearProgress />
            </DialogContent>
          </Dialog>
          <Dialog
            open={isToLiftSalary}
            onClose={() => cancelUpdateAdminSalaryStatus()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              <span style={{ fontSize: '20px' }}>
                {isValidBatch
                  ? 'Vahvista, että haluat jatkaa pankkimaksua'
                  : isIRValidBatch
                  ? 'Vahvista palkat, jotka haluat lähettää Tulorekisteriin'
                  : isIRCacelReportValidBatch
                  ? 'Vahvista palkat, joista haluat perua Tulorekisteriraportin'
                  : 'Valitse erikseen joko pankki hylännyt, pankki hyväksynyt , pankin käsittelyssä , makesttu tai TR hylätty olevat jatkaaksesi'}
              </span>
            </DialogTitle>
            <DialogActions>
              {!isImportSalary ? (
                <ul className="nav nav-pills pull-right">
                  <li>
                    <Button
                      style={{ margin: '20px' }}
                      onClick={() => {
                        cancelUpdateAdminSalaryStatus(selectedRows)
                      }}
                      variant="contained"
                    >
                      Peruuta
                    </Button>
                  </li>
                  {isValidBatch ? (
                    <>
                      <li>
                        <Button
                          style={{ margin: '20px' }}
                          onClick={() => {
                            if (isUlosottoSalaryMissingInfo) {
                              setUlosottoDialogType('ulosotto_missing_info')
                            } else if (isUlosottoSalaryMissingAmount) {
                              setAdditionalUlosottoDialog(true)
                            } else {
                              updateAdminSalaryStatus(selectedRows)
                            }
                          }}
                          variant="contained"
                        >
                          Pankin käsittelyssä
                        </Button>
                      </li>
                      <li>
                        <Button
                          style={{ margin: '20px' }}
                          onClick={() => {
                            setConfirmManualPayDialog(true)
                          }}
                          variant="contained"
                        >
                          Manuaalinen maksu
                        </Button>
                      </li>
                    </>
                  ) : null}
                  {isIRValidBatch ? (
                    <>
                      <li>
                        <Button
                          style={{ margin: '20px' }}
                          onClick={() => {
                            salarySendtoIR(selectedRows)
                          }}
                          variant="contained"
                        >
                          Lähetä TR
                        </Button>
                      </li>
                      <li>
                        <Button
                          style={{ margin: '20px' }}
                          onClick={() => {
                            updateSalaryStatusIR(selectedRows)
                          }}
                          variant="contained"
                        >
                          Manualinen TR
                        </Button>
                      </li>
                    </>
                  ) : null}
                  {isIRCacelReportValidBatch ? (
                    <>
                      <li>
                        <Button
                          style={{ margin: '20px' }}
                          onClick={() => {
                            cancelSalaryIRReport(selectedRows)
                          }}
                          variant="contained"
                        >
                          Peruuta TR raportti
                        </Button>
                      </li>
                    </>
                  ) : null}
                </ul>
              ) : (
                <ul className="nav nav-pills pull-right">
                  <li>
                    <Button
                      style={{ margin: '20px' }}
                      onClick={() => {
                        cancelUpdateAdminSalaryStatus(selectedRows)
                      }}
                      variant="contained"
                    >
                      Peruuta
                    </Button>
                  </li>
                  <li>
                    <Button
                      style={{ margin: '20px' }}
                      onClick={() => {
                        importKassavirtanenSalaries(selectedRows)
                      }}
                      variant="contained"
                    >
                      Maksettu
                    </Button>
                  </li>
                  {isIRValidBatch ? (
                    <div>
                      <li>
                        <Button
                          style={{ margin: '20px' }}
                          primary={true}
                          onClick={() => {
                            salarySendtoIR(selectedRows)
                          }}
                          variant="contained"
                        >
                          Lähetä TR
                        </Button>
                      </li>
                      <li>
                        <Button
                          style={{ margin: '20px' }}
                          primary={true}
                          onClick={() => {
                            updateSalaryStatusIR(selectedRows)
                          }}
                          variant="contained"
                        >
                          Manualinen TR
                        </Button>
                      </li>
                    </div>
                  ) : null}
                  {isIRCacelReportValidBatch ? (
                    <div>
                      <li>
                        <Button
                          style={{ margin: '20px' }}
                          primary={true}
                          onClick={() => {
                            cancelSalaryIRReport(selectedRows)
                          }}
                          variant="contained"
                        >
                          Cancel IR Salary Report
                        </Button>
                      </li>
                    </div>
                  ) : null}
                </ul>
              )}
            </DialogActions>
          </Dialog>
        </div>
      </div>
      <Dialog
        open={!!ulosottoDialogType}
        onClose={() => setUlosottoDialogType('')}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <span style={{ fontSize: '20px' }}>
            {
              ulosottoDialogType === 'ulosotto_disabled' 
                ? 'Ulosotto on poistettu käytöstä kyseiseltä käyttäjältä'
                : 'Ulosottopalkkojen maksua ei voida jatkaa'
            }
          </span>
        </DialogTitle>
        <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          style={{ fontSize: '15px' }}
        >
          {
            ulosottoDialogType === 'ulosotto_disabled' 
              ? (
                'Tämä palkka sisältää ulosoton summan, jonka ylläpitäjä on syöttänyt manuaalisesti. ' + 
                'Ulosotto-vaihtoehto on kuitenkin poistettu käytöstä kyseisen käyttäjän osalta. ' +
                'Ennen palkan maksamista ulosotto-vaihtoehto on otettava uudelleen käyttöön käyttäjäpaneelissa.'
              ) : (
                'Yrität maksaa ulosottopalkkoja ilman, että asiakkaan nostotilin numero ja/tai viitenumero on määritetty. ' +
                'Päivitä puuttuvat tiedot asiakkaan asiakastietoihin.'
              )
          }
        </DialogContentText>
        {
          ulosottoDialogType === 'ulosotto_missing_info' ? (
            <DialogActions>
              <ul className="nav nav-pills pull-right">
                <li>
                  <Button
                    style={{ marginLeft: '20px' }}
                    onClick={() => {
                      setUlosottoDialogType('')
                      handleChangeAdminMenu(0)
                      searchCompanyCustomers(
                        selectedRows.length > 1
                          ? selectedRows.find(
                              (item) => !item.withdrawal_reference_number
                            )?.email
                          : selectedRows[0].email
                      )
                    }}
                    variant="contained"
                  >
                    Ok
                  </Button>
                </li>
              </ul>
            </DialogActions>
          ) : null
        }
        </DialogContent>
      </Dialog>
      <Dialog
        open={!!confirmManualPayDialog}
        onClose={() => setConfirmManualPayDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <span style={{ fontSize: '20px' }}>
            Haluatko varmasti jatkaa manuaalista maksua?
          </span>
        </DialogTitle>
        <DialogContent>
          <DialogActions>
            <ul className="nav nav-pills pull-right">
              <li>
                <Button
                  style={{ marginLeft: '20px' }}
                  onClick={() => {
                    setConfirmManualPayDialog(false)
                  }}
                  variant="contained"
                >
                  Peruuta
                </Button>
                <Button
                  style={{ marginLeft: '20px' }}
                  onClick={() => {
                    setConfirmManualPayDialog(false)
                    manualPaySalaries(selectedRows)
                  }}
                  variant="contained"
                >
                  Manuaalinen maksu
                </Button>
              </li>
            </ul>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  )
}

function addLineBreaks(string) {
  const subStrings = string.split(',')
  const element = subStrings.map((str, index) => (
    <React.Fragment key={index}>
      {str}
      {index === subStrings.length - 1 ? '' : ','}
      <wbr />
    </React.Fragment>
  ))
  return element
}

const createSalaryRow = (
  classes,
  wages,
  selected,
  warnSalaryToPay,
  showSalaryPDF,
  adminSalaryPageSize,
  expandAdminSalary,
  shouldCloseSalaryForms,
  selectedIndex,
  setSelectedIndex,
  setUlosottoDialogType,
  open,
  setOpen,
  handleExpand
) => {
  return wages
    .slice(
      selected * adminSalaryPageSize,
      selected * adminSalaryPageSize + adminSalaryPageSize
    )
    .map((el, index) => (
      <SalaryAdminRow
        classes={classes}
        el={el}
        index={index}
        key={index}
        pageIndex={selected}
        showSalaryPDF={showSalaryPDF}
        expandAdminSalary={expandAdminSalary}
        warnSalaryToPay={warnSalaryToPay}
        shouldCloseSalaryForms={shouldCloseSalaryForms}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
        adminSalaryPageSize={adminSalaryPageSize}
        setUlosottoDialogType={setUlosottoDialogType}
        open={open}
        setOpen={setOpen}
        handleExpand={handleExpand}
      />
    ))
}

const SalaryAdminRow = ({
  classes,
  el,
  index,
  pageIndex,
  showSalaryPDF,
  warnSalaryToPay,
  shouldCloseSalaryForms,
  selectedIndex,
  adminSalaryPageSize,
  setUlosottoDialogType,
  open,
  setOpen,
  handleExpand
}) => {
  const dispatch = useDispatch()

  const globalIndex = useMemo(() => {
    return pageIndex * adminSalaryPageSize + index
  }, [pageIndex, adminSalaryPageSize, index])

  const ulosottoAmount = getUlosottoValue(
    el, 
    {
      brutto: el['brutto_sum_govpay'], 
      normal: el['normal_govpay_sum'], 
      manual: el['manual_sum_govpay'], 
      ulosotto: el['ulosotto_sum_govpay']
    }
  )

  const shouldDisablePay =
    el.status === 'BankingInitiation' ||
    el.dedtstatus === 'BankingInitiation' ||
    (el.status === 'bankingprocess' &&
      el.dedtstatus === 'bankingprocess') ||
    (el.status === 'bankingprocess' && el.dedtstatus === 'paid') ||
    (el.status === 'bankingprocess' &&
      el.dedtstatus === 'Pplasku') ||
    el.status === 'IRManual' ||
    el.status === 'IRinitiated' ||
    (el.status === 'processing' && (
      (el.ismanualgovpay && el.Salary_type !== 'manual_govpay') ||
      (el.isgovpay && el.Salary_type !== 'govpay')
    ))
      ? true
      : false

  // Close expanded salary row when search salary
  React.useEffect(() => {
    if (shouldCloseSalaryForms && open) {
      setOpen(false)
      dispatch(deleteDynamicForm('adminSalaryForm' + globalIndex))
    }
  }, [shouldCloseSalaryForms, setOpen])

  React.useEffect(() => {
    if (open) {
      setOpen(false)
      dispatch(deleteDynamicForm('adminSalaryForm' + globalIndex))
    }
  }, [pageIndex, setOpen])

  return (
    <>
      <TableRow key={el.email + el.id}>
        <TableCell
          className={classes.tableCell}
          style={{
            paddingLeft: '8px',
            paddingRight: '4px',
            textAlign: 'left'
          }}
        >
          {el.id}
        </TableCell>
        <TableCell
          className={classNames(classes.tableCell, classes.invoiceCell)}
          style={{
            whiteSpace: 'normal',
            paddingLeft: '2px',
            paddingRight: '2px',
            whiteSpace: 'normal',
            whiteSpace: 'normal',
            overflowWrap: 'break-word',
            textAlign: 'left'
          }}
        >
          {addLineBreaks(el.salariesinvoices)}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            whiteSpace: 'normal',
            paddingLeft: '2px',
            paddingRight: '2px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            textAlign: 'left'
          }}
        >
          {el.firstname + ' ' + el.lastname}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            paddingLeft: '2px',
            paddingRight: '2px',
            textAlign: 'right',
            whiteSpace: 'normal',
            wordWrap: 'break-word'
          }}
        >
          {new DateTimeFormat('fi', {
            day: 'numeric',
            month: 'numeric',
            year: '2-digit'
          }).format(new Date(el.created))}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            paddingLeft: '2px',
            paddingRight: '2px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            textAlign: 'right'
          }}
        >
          {el.gross_salary.toLocaleString('fi-FI', {
            minimumFractionDigits: 2
          })}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            paddingLeft: '2px',
            paddingRight: '2px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            textAlign: 'right'
          }}
        >
          {el.net_salary.toLocaleString('fi-FI', {
            minimumFractionDigits: 2
          })}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            paddingLeft: '2px',
            paddingRight: '2px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            textAlign: 'right'
          }}
        >
          {el.tax_cost.toLocaleString('fi-FI', { minimumFractionDigits: 2 })}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            paddingLeft: '2px',
            paddingRight: '2px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            textAlign: 'right'
          }}
        >
          {el.yel_cost.toLocaleString('fi-FI', { minimumFractionDigits: 2 })}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            paddingLeft: '2px',
            paddingRight: '2px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            textAlign: 'right'
          }}
        >
          {el.social_contribution.toLocaleString('fi-FI', {
            minimumFractionDigits: 2
          })}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            paddingLeft: '2px',
            paddingRight: '2px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            textAlign: 'right'
          }}
        >
          {el.service_cost.toLocaleString('fi-FI', {
            minimumFractionDigits: 2
          })}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            paddingLeft: '2px',
            paddingRight: '2px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            textAlign: 'right'
          }}
        >
          {el.mileage_allowance.toLocaleString('fi-FI', {
            minimumFractionDigits: 2
          })}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            paddingLeft: '2px',
            paddingRight: '2px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            textAlign: 'right'
          }}
        >
          {(
            el.full_time_allowance +
            el.part_time_allowance +
            el.meal_allowance
          ).toLocaleString('fi-FI', { minimumFractionDigits: 2 })}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            paddingLeft: '1px',
            paddingRight: '1px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            textAlign: 'right'
          }}
        >
          {el.reimbursment_cost.toLocaleString('fi-FI', {
            minimumFractionDigits: 2
          })}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            paddingLeft: '2px',
            paddingRight: '2px',
            whiteSpace: 'normal',
            whiteSpace: 'nowrap',
            textAlign: 'right'
          }}
        >
          {ulosottoAmount.toLocaleString('fi-FI', {
            minimumFractionDigits: 2
          })}
          {getUlosottoValue(
            el, 
            {
              brutto: '(B)', 
              normal: '(N)', 
              manual: '(M)', 
              ulosotto: ''
            }
          )}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            paddingLeft: '2px',
            paddingRight: '8px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            textAlign: 'right'
          }}
        >
          {el.take_home_pay.toLocaleString('fi-FI', {
            minimumFractionDigits: 2
          })}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            paddingLeft: '8px',
            paddingRight: '2px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            textAlign: 'left'
          }}
        >
          {convertNameToState(el.dedtstatus)}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            paddingLeft: '8px',
            paddingRight: '2px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            textAlign: 'left'
          }}
        >
          {convertNameToState(el.bank_ulosotto_status)}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            paddingLeft: '2px',
            paddingRight: '2px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            textAlign: 'left'
          }}
        >
          {convertNameToState(el.status)}
        </TableCell>
        <TableCell
          className={classes.tableCell}
          style={{
            paddingLeft: '2px',
            paddingRight: '2px',
            whiteSpace: 'normal',
            wordWrap: 'break-word',
            textAlign: 'right'
          }}
        >
          <div style={{ display: 'flex' }}>
            <Checkbox
              onClick={() => {
                if (
                  !(el.isgovpay || el.ismanualgovpay) && 
                  (el.ulosotto_sum_govpay > 0 || el.manual_sum_govpay > 0)
                ) {
                  setUlosottoDialogType('ulosotto_disabled')
                } else {
                  if (
                    (el.isgovpay || el.ismanualgovpay) &&
                    !(el.ulosotto_sum_govpay > 0 || el.manual_sum_govpay > 0)
                  ) {
                    warnSalaryToPay(
                      `${el.uuid}$$${el.id}$$${el.status}$$${el.dedtstatus}$$${index}`
                    )
                  } else {
                    warnSalaryToPay(
                      `${el.uuid}$$${el.id}$$${el.status}$$${el.dedtstatus}`
                    )
                  }
                }
              }}
              disabled={shouldDisablePay}
              checked={el.isChecked}
              style={{ maxWidth: '1%' }}
              icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
              checkedIcon={
                <CheckBoxIcon fontSize="large" style={{ fill: '#F67131' }} />
              }
            />
            <p
              style={{ marginLeft: '10px', marginTop: '12px' }}
              className="link"
              onClick={() => {
                showSalaryPDF(el.id, el.uuid, el.invoice_uuid)
              }}
            >
              <FontAwesome
                name="file-pdf-o"
                title="Tallenna palkkalaskelma PDF-tiedostona"
              />
            </p>
            {
              (
                el.status === 'processing' && 
                (el.isgovpay || el.ismanualgovpay)
              ) || 
              ['brutto_govpay', 'normal_govpay', 'govpay', 'manual_govpay']
                .includes(el.Salary_type)
                ? (
                  <p
                    style={{
                      marginLeft: '10px',
                      color: 'Red',
                      marginTop: '12px',
                      marginRight: '15px'
                    }}
                    className="link"
                  >
                    <FontAwesome
                      name="fas fa-exclamation-triangle"
                      title="Ulosotto"
                    />
                  </p>
                ) : (
                  <p
                    style={{
                      marginLeft: '10px',
                      color: 'Gray',
                      marginTop: '12px',
                      marginRight: '15px'
                    }}
                    className="link"
                  >
                    <FontAwesome
                      name="fas fa-exclamation-triangle"
                      title="Ei ulosottoa"
                    />
                  </p>
                )
            }
            {
              el.status === 'processing' &&
              (el.isgovpay || el.ismanualgovpay) &&
              !(el.brutto_sum_govpay || el.normal_govpay_sum) 
                ? (
                  <p>
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      onClick={() => handleExpand(el, globalIndex, index)}
                      style={{ marginLeft: '8px' }}
                    >
                      {open && selectedIndex === index ? (
                        <KeyboardArrowUp fontSize="large" />
                      ) : (
                        <KeyboardArrowDown fontSize="large" />
                      )}
                    </IconButton>
                  </p>
                ) 
                : null
            }
          </div>
        </TableCell>
      </TableRow>
      {
        <TableRow style={{ height: '0px' }}>
          <TableCell
            style={{
              fontSize: '13px',
              borderBottom: '1px solid lightgray',
              padding: '0px 0px'
            }}
            colSpan={18}
          >
            <Collapse
              in={open && selectedIndex === index}
              timeout="auto"
              unmountOnExit
            >
              <div style={{ padding: '20px', paddingTop: '40px' }}>
                {el.expanded
                  ? expandedSalaryFormData(el.expandData, globalIndex, setOpen)
                  : null}
              </div>
            </Collapse>
          </TableCell>
        </TableRow>
      }
    </>
  )
}

// Expanded salary row
const expandedSalaryFormData = (expandData, index, setOpen) => (
  <AdminSalaryFormContainer
    initialValues={expandData}
    index={index}
    setOpen={setOpen}
  />
)

const createSalaryExcelReportButton = (
  salaries = [],
  salarySearchSummary = {},
  selected,
  adminSalaryPageSize,
  startDate,
  endDate,
  allSalaryRecords
) => {
  if (salaries.length <= 0) {
    return
  }

  // Table columns
  const salariesColumns = [
    {
      name: 'Tunnus',
      filterButton: true
    },
    {
      name: 'Laskut',
      filterButton: true
    },
    {
      name: 'Nimi',
      filterButton: true
    },
    {
      name: 'PVM',
      filterButton: true
    },
    {
      name: 'Brutto',
      filterButton: true
    },
    {
      name: 'Netto',
      filterButton: true
    },
    {
      name: 'Ennakon-pidätys',
      filterButton: true
    },
    {
      name: 'YEL',
      filterButton: true
    },
    {
      name: 'Sotu',
      filterButton: true
    },
    {
      name: 'PP',
      filterButton: true
    },
    {
      name: 'Km',
      filterButton: true
    },
    {
      name: 'Päiväraha',
      filterButton: true
    },
    {
      name: 'Kuitit',
      filterButton: true
    },
    {
      name: 'Uo',
      filterButton: true
    },
    {
      name: 'Maksetaan',
      filterButton: true
    },
    {
      name: 'Vähennystila',
      filterButton: true
    },
    {
      name: 'Ulosottotila',
      filterButton: true
    },
    {
      name: 'Tila',
      filterButton: true
    }
  ]

  const summaryColumns = [
    { name: 'Bruttopalkka' },
    { name: 'Ennakonpidätys' },
    { name: 'Kilometrikorvaus' },
    { name: 'Päiväraha' },
    { name: 'Palvelupalkkiovähennys' },
    { name: 'Sotu-vähennys' },
    { name: 'Maksetaan' },
    { name: 'YEL' },
    { name: 'Ulosotto' },
    { name: 'Muut kulukorvaukset (kuitit)' },
    { name: 'Muut kulukorvaukset (kuitit) ALV-määrä' },
    { name: 'Kuitit (ALV 25,5%)' },
    { name: 'Kuitit (ALV 24%)' },
    { name: 'Kuitit (ALV 14%)' },
    { name: 'Kuitit (ALV 10%)' },
    { name: 'Kuitit (ALV 0%)' }
  ]

  // Table rows
  const salariesRows = (
    startDate !== null && endDate !== null
      ? allSalaryRecords
      : salaries.slice(0, selected * adminSalaryPageSize + adminSalaryPageSize)
  ).map((salary) => {
    const ulosottoAmount = getUlosottoValue(
      salary, 
      {
        brutto: salary['brutto_sum_govpay'], 
        normal: salary['normal_govpay_sum'], 
        manual: salary['manual_sum_govpay'], 
        ulosotto: salary['ulosotto_sum_govpay']
      }
    )

    return [
      salary.id,
      salary.salariesinvoices,
      `${salary.firstname} ${salary.lastname}`,
      new DateTimeFormat('fi', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
      }).format(new Date(salary.created)),
      salary.gross_salary.toLocaleString('fi-FI', {
        minimumFractionDigits: 2
      }),
      salary.net_salary.toLocaleString('fi-FI', {
        minimumFractionDigits: 2
      }),
      salary.tax_cost.toLocaleString('fi-FI', {
        minimumFractionDigits: 2
      }),
      salary.yel_cost.toLocaleString('fi-FI', {
        minimumFractionDigits: 2
      }),
      salary.social_contribution.toLocaleString('fi-FI', {
        minimumFractionDigits: 2
      }),
      salary.service_cost.toLocaleString('fi-FI', {
        minimumFractionDigits: 2
      }),
      salary.mileage_allowance.toLocaleString('fi-FI', {
        minimumFractionDigits: 2
      }),
      (
        salary.full_time_allowance +
        salary.part_time_allowance +
        salary.meal_allowance
      ).toLocaleString('fi-FI', {
        minimumFractionDigits: 2
      }),
      salary.reimbursment_cost.toLocaleString('fi-FI', {
        minimumFractionDigits: 2
      }),
      ulosottoAmount.toLocaleString('fi-FI', {
        minimumFractionDigits: 2
      }),
      salary.take_home_pay.toLocaleString('fi-FI', {
        minimumFractionDigits: 2
      }),
      convertNameToState(salary.dedtstatus),
      convertNameToState(salary.bank_ulosotto_status),
      convertNameToState(salary.status)
    ]
  })

  const summaryRows = [
    [
      new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(salarySearchSummary.total_gross_salary),
      new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(salarySearchSummary.total_tax_cost),
      new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(salarySearchSummary.total_mileage_allowance),
      new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(salarySearchSummary.total_daily_allowance),
      new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(salarySearchSummary.total_service_cost),
      new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(salarySearchSummary.total_social_contribution),
      new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(salarySearchSummary.total_take_home_pay),
      new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(salarySearchSummary.total_yel_cost),
      new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(salarySearchSummary.total_ulosotto_sum),
      new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(salarySearchSummary.total_reimbursment_cost),
      new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(salarySearchSummary.expenses.total_vat_amount),
      new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(salarySearchSummary.expenses.sum_incl_vat_25_5),
      new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(salarySearchSummary.expenses.sum_incl_vat_24),
      new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(salarySearchSummary.expenses.sum_incl_vat_14),
      new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(salarySearchSummary.expenses.sum_incl_vat_10),
      new Intl.NumberFormat('fi-FI', {
        style: 'currency',
        currency: 'EUR'
      }).format(salarySearchSummary.expenses.sum_incl_vat_0)
    ]
  ]

  // Create Workbook and Worksheet
  const workbook = new ExcelJS.Workbook()
  workbook.creator = 'Me'
  workbook.lastModifiedBy = 'Her'
  const salariesWorksheet = workbook.addWorksheet('Salaries')
  const summaryWorksheet = workbook.addWorksheet('Summary')

  // Salaries Worksheet Header
  salariesWorksheet.mergeCells('A2:2')
  const salariesHeaderCell = salariesWorksheet.getCell('A2')
  salariesHeaderCell.font = {
    name: 'Times New Roman',
    family: 4,
    size: 20,
    underline: true,
    bold: true
  }
  salariesWorksheet.views = [
    { state: 'frozen', xSplit: 0, ySplit: 5, topLeftCell: 'A6' }
  ]
  salariesHeaderCell.width = 5
  salariesHeaderCell.value = 'Salaries Report'

  // Summary Worksheet Header
  summaryWorksheet.mergeCells('A2:O2')
  const summaryHeaderCell = summaryWorksheet.getCell('A2')
  summaryHeaderCell.font = {
    name: 'Times New Roman',
    family: 4,
    size: 20,
    underline: true,
    bold: true
  }
  summaryHeaderCell.width = 5
  summaryHeaderCell.value = 'Salaries Summary Report'

  // Add Salaries Table To Worksheet
  salariesWorksheet.addTable({
    name: 'Salaries',
    ref: 'A5',
    headerRow: true,
    style: {
      theme: 'TableStyleMedium9',
      showRowStripes: true
    },
    columns: salariesColumns,
    rows: salariesRows
  })
  // Add Summary Table To Worksheet
  summaryWorksheet.addTable({
    name: 'Summary',
    ref: 'A5',
    headerRow: true,
    style: {
      theme: 'TableStyleMedium9',
      showRowStripes: true
    },
    columns: summaryColumns,
    rows: summaryRows
  })

  // Style The Salaries Table
  for (let i = 0; i < salariesColumns.length; i++) {
    salariesWorksheet.getColumn(i + 1).width = 15
  }
  salariesWorksheet.getRow(5).height = 42.5
  const salariesTableRows = salariesWorksheet.getRows(
    6,
    6 + salariesRows.length
  )
  for (let row of salariesTableRows) {
    row.height = 30
  }

  // Style the Summary Table
  for (let i = 0; i < summaryColumns.length; i++) {
    summaryWorksheet.getColumn(i + 1).width = 20
  }
  summaryWorksheet.getRow(5).height = 42.5
  const summaryTableRows = summaryWorksheet.getRows(6, 6 + summaryRows.length)
  for (let row of summaryTableRows) {
    row.height = 30
  }

  const handleExport = async () => {
    try {
      const buffer = await workbook.xlsx.writeBuffer()
      saveAs(
        new Blob([buffer], { type: 'application/octet-stream' }),
        'salaries.xlsx'
      )
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Button
      style={{ margin: '20px' }}
      onClick={handleExport}
      variant="contained"
    >
      Download Excel Report
    </Button>
  )
}

const getUlosottoValue = (salary, ulosottoOpt) => {
  const salaryType = salary['Salary_type']
  const status = salary['status']
  const isUserCurrentlyManualGovpay = salary['ismanualgovpay']

  return (
    salaryType === 'brutto_govpay'
      ? ulosottoOpt['brutto']
      : salaryType === 'normal_govpay'
        ? ulosottoOpt['normal']
        : (
            salaryType === 'manual_govpay' ||
            (
              status === 'processing' && 
              salaryType === 'none' &&
              isUserCurrentlyManualGovpay
            )
        )
          ? ulosottoOpt['manual']
          : ulosottoOpt['ulosotto']
  )
}

export default withStyles(styles)(SalaryPanel)
